import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IUser } from '@ztarmobile/zwp-services-auth';
import { ContactEmailService, FirebaseUserProfileService } from '@ztarmobile/zwp-service-backend';
import { SUPPORT_ROUTE_URLS, ACCOUNT_ROUTE_URLS } from '../../app.routes.names';
import { MetaService } from '../../../services/meta-service.service';
import { ToastrHelperService } from '../../../services/toast-helper.service';
import { CAPTCHA_BOT_ERROR_CODE, EMAIL_PATTERN } from 'src/app/app.config';
import { AppState } from '@app/app.service';
import { ModalHelper } from '@services/modal-helper.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnDestroy, OnInit {
  public contactUsForm: FormGroup;
  public userInfo: IUser = {} as IUser;
  public ACCOUNT_ROUTE_URLS = ACCOUNT_ROUTE_URLS;
  public SUPPORT_ROUTE_URLS = SUPPORT_ROUTE_URLS;
  public processingRequest = false;
  public submittedRequest = true;
  public isOpened = false;
  public innerWidth: any;
  public recaptchaResolvedSubscription: Subscription;

  private captchaResponse: string;
  private userObserver: Subscription;

  constructor(private formBuilder: FormBuilder, private router: Router,
    private contactEmailService: ContactEmailService, private userProfileService: FirebaseUserProfileService,
    private toastHelper: ToastrHelperService, private metaService: MetaService,
    private appState: AppState, private modalHelper: ModalHelper) {

    this.contactUsForm = formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.pattern(EMAIL_PATTERN)])],
      name: ['', Validators.compose([Validators.required, Validators.pattern('^[A-Za-z]+[ \t]?[A-Za-z]+[ \t]?[A-Za-z ]*$')])],
      phone: [''],
      category: ['Billing'],
      message: ['', Validators.required],
      contact: ['']
    });
    this.userObserver = this.userProfileService.userProfileObservable.subscribe((user) => {
      if (!!user) {
        this.userInfo = Object.assign({}, user);
        this.contactUsForm.controls.name.setValue(this.userInfo.firstName + ' ' + this.userInfo.lastName);
        this.contactUsForm.controls.email.setValue(this.userInfo.email);
      } else {
        this.userInfo.firstName = '';
        this.userInfo.lastName = '';
        this.userInfo.contactPhone = '';
        this.contactUsForm.controls.name.setValue('');
        this.contactUsForm.controls.email.setValue('');
      }
    });
  }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    this.metaService.createCanonicalUrl();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.innerWidth = window.innerWidth;
  }

  ngOnDestroy(): void {
    if (!!this.userObserver) {
      this.userObserver.unsubscribe();
    }
    if (this.recaptchaResolvedSubscription) {
      this.recaptchaResolvedSubscription.unsubscribe();
    }
  }
  public goToILDaddon(): void {
    const params = {};
    params[ACCOUNT_ROUTE_URLS.PARAMS.INTERNATIONAL_CALLING] = true;
    this.router.navigate([`${ACCOUNT_ROUTE_URLS.BASE}/${ACCOUNT_ROUTE_URLS.PLAN_ADD_ONS}`, params]);
  }
  public sendMessage(): void {
    const action = 'freeup_contact_us';
    if(!!this.contactUsForm.valid) {
      this.processingRequest = true;
      this.appState.loading = true;
      this.appState.resetAndExecuteCaptchaSubject.next({action});
      this.recaptchaResolvedSubscription= this.appState.resolvedCaptcha.subscribe(response => {
        this.captchaResponse = response;
        if(!!this.captchaResponse) {
          this.recaptchaResolvedSubscription?.unsubscribe();
          this.callContactEmailService(this.captchaResponse, true, action);
        }
      });
    }
  }

  public callContactEmailService(captchaRes, invisibleCaptchaRes, action?): void {
    const nameArr = this.contactUsForm.get('name').value.split(/\s+/);
    const fname = nameArr.slice(0, -1).join(' ');
    const lname = nameArr.pop();
    this.contactEmailService.sendContactUsEmail({
      reCaptcha: captchaRes,
      email: this.contactUsForm.get('email').value,
      message: this.contactUsForm.get('message').value,
      firstName: fname,
      lastName: lname,
      phoneNumber: this.contactUsForm.get('phone').value,
      category: this.contactUsForm.get('category').value,
      contactNumber: this.contactUsForm.get('contact').value,
    }, !!action? action: null, invisibleCaptchaRes).then(() => {
      this.processingRequest = false;
      this.submittedRequest = false;
      this.appState.loading = false;
      this.contactUsForm.reset();
      this.contactUsForm.controls.category.setValue('Billing');
    },
      (error) => {
        this.processingRequest = false;
        this.appState.loading = false;
        if(error?.error?.code === CAPTCHA_BOT_ERROR_CODE) {
          this.modalHelper.showRecaptchaVerificationModal().afterClosed().subscribe((result)=> {
            if(!!result) {
              this.processingRequest = true;
              this.appState.loading = true;
              this.callContactEmailService(result, false);
            }
          });
         } else {
          this.toastHelper.showAlert(error?.error?.message);
         }
        this.recaptchaResolvedSubscription?.unsubscribe();
      });
  }
  public goBack(): void {
    this.submittedRequest = true;
  }
}

